import { useState, useEffect } from 'react';
import logoMark from '../assets/logo-gestion360.png';
import { BRAND } from '../config/brand';
import { getLegalInfo } from '../lib/org';
import { termsDoc, privacyDoc, LEGAL_UPDATED, LEGAL_VERSION } from '../legal/documents';

// Páginas públicas /terminos y /privacidad
export default function LegalPage({ kind, onHome }) {
  const [info, setInfo] = useState({});
  useEffect(() => { getLegalInfo().then(setInfo).catch(() => {}); }, []);
  const doc = kind === 'terms' ? termsDoc(info) : privacyDoc(info);
  useEffect(() => { const t = document.title; document.title = `${doc.title} · ${BRAND.product}`; return () => { document.title = t; }; }, [doc.title]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div style={{ background: 'linear-gradient(135deg,#0f172a 0%,#1e293b 100%)' }}>
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <button onClick={onHome} className="flex items-center gap-2">
            <img src={logoMark} alt={BRAND.product} className="w-8 h-8 rounded-2xl" />
            <span className="text-white font-bold tracking-tight">{BRAND.product}</span>
          </button>
          <div className="flex gap-4 text-xs font-bold">
            <a href="/terminos" className={kind === 'terms' ? 'text-white' : 'text-white/60'}>Términos</a>
            <a href="/privacidad" className={kind === 'privacy' ? 'text-white' : 'text-white/60'}>Privacidad</a>
          </div>
        </div>
      </div>
      <article className="max-w-3xl mx-auto px-5 py-8">
        <h1 className="text-2xl sm:text-3xl font-black text-gray-900 tracking-tight">{doc.title}</h1>
        <p className="text-xs text-gray-400 mt-1">Versión {LEGAL_VERSION} · Actualizada el {LEGAL_UPDATED}</p>
        <p className="text-sm text-gray-700 leading-relaxed mt-5">{doc.intro}</p>
        {doc.sections.map((s) => (
          <section key={s.h} className="mt-7">
            <h2 className="text-base font-bold text-gray-900">{s.h}</h2>
            {s.p.map((t, i) => <p key={i} className="text-sm text-gray-700 leading-relaxed mt-2">{t}</p>)}
          </section>
        ))}
      </article>
    </div>
  );
}
